export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "サインイン",
    "login.form.hint.user": "ログイン",
    "login.form.hint.password": "パスワード",
    "login.form.checkbox.remember-me": "ログイン情報を記憶",
    "login.form.button.sign-in": "サインイン",
    "login.form.message.invalid-user-credentials": "ログイン ID またはパスワードが正しくありません",
    "login.form.message.account-temporarily-locked": "アカウントは一時的にロックされており、5分後に解除されます。",
    "login.form.message.user-required": "ログインIDを入力してください",
    "login.form.message.password-required": "パスワードを入力してください",
    "login.form.button.forgot-password": "パスワードを忘れた場合",
    "error.mfa-required.title": "二要素認証のセットアップ",
    "error.mfa-required.message1": "二要素認証（2FA）は、アカウントを保護するために必要です。",
    "error.mfa-required.message2": "オンラインダッシュボードのアカウント設定にリダイレクトされます。二要素認証を有効にし、セットアップ手順に従ってから、ここに戻ってください。",
    "error.mfa-required.learnMore": "二要素認証についての詳細",
    "error.mfa-required.continue": "続行",
    "error.root-admin-login.title": "エラー 403: 禁止",
    "error.root-admin-login.message": "読み取り専用管理者としてログイン済みです。Web Recovery コンソールにアクセスするには、カスタマーテナントのユーザーまたは管理者としてログインしてください",
    "error.server-busy.message": "サーバーが混雑しています。後でやり直してください。",
    "error.network-connection.title": "ネットワーク接続エラー",
    "error.network-connection.message": "インターネット接続を確認して、やり直してください。",
    "error.internal-server-error.title": "内部サーバーエラー",
    "error.internal-server-error.message": "エラーを解決するには、エラーの詳細をサポートまでお知らせください:",
    "error.internal-server-error.copy.button": "コピー"
};
